<template>
  <div class="max-w-[1100px] w-full mx-auto">
    <section class="flex items-center ml-4 sm:ml-0 mb-6 mt-8 sm:mt-9 sm:mb-9">
      <OIcon icon="heart-circle" svg-class="w-5 h-5 sm:w-[30px] sm:h-[30px]" />
      <h2 class="font-semibold text-20 sm:text-24 text-black ml-2.5">{{ $t('game.favorites') }}</h2>
    </section>
    <div class="flex flex-wrap justify-center sm:justify-start gap-4 sm:gap-5 mb-5">
      <GameCard v-for="game in favorites" :key="game.id" :game="game" source="Favorites" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import GameCard from './GameCard.vue';
import { useDevice } from '~/composables/useDevice';
import gameData from '~/modules/oyun/gameData';
import { LANG } from '~/constants/config';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  setup() {
    const { isMobile } = useDevice();
    const games = gameData.filter((game) => game.description[LANG]);
    const favoritesGamesId = [48, 47, 46, 45, 44, 43];
    const favorites = computed(() => {
      const temp = favoritesGamesId
        .map((id) => {
          return games.find((game) => game.id === id);
        })
        .filter(Boolean);

      return temp.slice(0, isMobile.value ? 5 : 5);
    });
    return { isMobile, favorites };
  },
  components: {
    GameCard,
    OIcon,
  },
});
</script>
